import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/store/reducers";
import { Post } from "./Post";
import { useGetPostsMutation } from "@/services/modules/post";
import { PostType } from "../../types";

export const Posts = ({
  getUserPost,
  isArticle,
}: {
  getUserPost?: boolean;
  isArticle?: boolean;
}) => {
  const [getPosts] = useGetPostsMutation();
  const posts = useSelector((state: RootState) => state.post.postList);

  useEffect(() => {
    getPosts({
      getUserPost,
      type: isArticle ? PostType.Article : PostType.Post,
    });
  }, [getUserPost]);

  return (
    <div className="pl-[100px] pr-[100px]">
      {posts.map((post) => (
        <Post postDetail={post} key={post.postId} isArticle={isArticle} />
      ))}
    </div>
  );
};
